module.exports = __webpack_public_path__ + "static/media/performance-graphs.950cb1cd.svg";